<template>
  <div class="helpRealBox">
    <div class="bigTitle" @click="backFn('showa')">
      <span></span>个人实名认证
    </div>
    <div class="smallTile" v-for="(item,index) in flowList" v-if="showa">
      <p>{{item.con}}</p>
      <img :src="item.img" v-if="item.img!=''">
    </div>
    <div class="helpcloginCon">
      <div class="bigTitle" @click="backFn('showb')">
        <span></span>企业实名认证
      </div>
      <div class="smallTile" v-if="showb">
        <div v-for="(item,index) in enterpriseList">
          <p>{{item.con}}</p>
          <img :src="item.img" v-if="item.img!=''">
        </div>
      </div>
      <div class="bigTitle" @click="backFn('showc')">
        <span></span>实名认证常见问题
      </div>
      <div class="helpItem" v-if="showc">
        <div v-for="item in realList">
          <p>
            <span></span>
            {{item.problem}}
          </p>
          <p v-for="answerTitle in item.answer">
            <span></span>
            {{answerTitle}}
          </p>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      showa: false,
      showb: false,
      showc: false,
      flowList: [
        {
          con: "1.用户中心-个人中心-个人认证",
          img: require("../../../assets/images/helpCenter/grrz.png")
        },
        {
          con: "2.点击“下一步”",
          img: require("../../../assets/images/helpCenter/gr.png")
        },
        {
          con: "3.输入用户真实姓名、身份证号码",
          img: ""
        },
        {
          con: "4.上传身份证正面照、身份证反面照、手持身份证照",
          img: ""
        },
        {
          con: "5.点击提交",
          img: ""
        },
        {
          con: "6.审核通过后完成个人实名认证"
          // img:require('')
        }
      ],
      enterpriseList: [
        {
          con: "1.用户中心-个人中心-企业认证",
          img: require("../../../assets/images/helpCenter/qy.png")
        },
        {
          con: "2.填写基本信息",
          img: require("../../../assets/images/helpCenter/qysm.png")
        },
        {
          con: "3.上传文件",
          img: require("../../../assets/images/helpCenter/fr.png")
        },
        {
          con: "4.点击确定",
          img: ""
        },
        {
          con: "5.填写法人代表信息",
          img: ""
        },
        {
          con: "6.上传企业法人身份证",
          img: ""
        },
        {
          con: "7.点击下一步",
          img: ""
        },
        {
          con: "8.审核通过后完成企业实名认证",
          img: ""
        }
      ],
      realList: [
        {
          problem: "个人实名认证的方式有几种，智签支持的方式是什么？",
          answer: [
            "目前市场上的认证方式有：手机号认证、银行卡认证、人脸比对认证、手持身份证认证等方式，智签为了保证用户实名的严谨性，目前是手机号与手持身份证结合的方式进行的个人实名认证，后续会开放支持银行卡四要素认证及人脸对比认证。"
          ]
        }
      ]
    };
  },
  methods: {
    backFn(flag) {
      if (this[flag] == true) {
        this[flag] = false;
      } else {
        this[flag] = true;
      }
    }
  }
};
</script>


